import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from "@angular/core";
import {NotificationService} from "../../../notification/notification.service";
import {OrderModel} from "../../order.model";
import {MessageDetails, MessageLevel} from "../../../notification/message/message";
import {OrderItem} from "../../order";

@Component({
    selector: "woa-order-item-quantity-control",
    templateUrl: "./order-item-quantity-control.component.html"
})
export class OrderItemQuantityControlComponent {
    @Input() orderItem: OrderItem;
    @Input() originalOrderItem: OrderItem;
    @Input() transparent: boolean = false;
    @Input() disabled: boolean = false;

    @Output() quantityChanged: EventEmitter<void> = new EventEmitter();

    constructor(private orderModel: OrderModel,
                private notificationService: NotificationService,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    get canDecrement(): boolean {
        return !this.disabled && this.orderItem.quantity > (this.orderItem.sellable.minWebOrderQty || 1);
    }

    get canIncrement(): boolean {
        return !this.disabled && !this.orderModel.orderItemAtLimit(this.orderItem, 1, this.orderItem.quantity, this.originalOrderItem);
    }

    async decrementQuantity(): Promise<void> {
        if (!this.canDecrement) {
            if (this.orderItem.sellable.minWebOrderQty > 1) {
                return this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, "woa.message.order.productMinimumReached", {
                    item: this.orderItem.menuItem.name,
                    minimum: this.orderItem.sellable.minWebOrderQty
                }));
            }
            return;
        }
        this.orderItem.decrementQuantity();
        this.changeDetectorRef.detectChanges();
        this.quantityChanged.emit();
    }

    async incrementQuantity(): Promise<void> {
        if (!this.canIncrement) {
            return this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, "woa.message.order.productLimitReached", {
                item: this.orderItem.menuItem.name
            }));
        }
        this.orderItem.incrementQuantity();
        this.changeDetectorRef.detectChanges();
        this.quantityChanged.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-item/order-item-quantity-control/order-item-quantity-control.component.ts